<template>
	<div
		class="db2-card"
		:class="{ 'is-edit': isEditMode, 'is-selected': selected, 'is-divider': card.type === 'divider', 'is-kpi': card.type === 'kpi', 'is-energy': card.type === 'energy', 'is-equip': card.type === 'equipment', 'is-alerts': card.type === 'alerts', 'is-wo': card.type === 'workOrders', 'is-trend': card.type === 'trend', 'is-donut': card.type === 'donut', 'is-note': card.type === 'text' }"
		@mousedown.self="onSelect"
		@click="onSelect"
	>
		<div class="db2-card-head" v-if="showHead" @mousedown="onDragStart">
			<v-icon v-if="isEditMode" small class="db2-card-drag">mdi-drag</v-icon>
			<div class="db2-card-title">{{ card.name }}</div>
		</div>
		<div class="db2-card-body" @mousedown="onBodyDown">
			<slot />
		</div>
		<div
			v-if="isEditMode && selected"
			class="db2-card-fab"
			@mousedown.stop
		>
			<v-btn icon x-small title="Move" @mousedown.stop="onDragStart"><v-icon small>mdi-drag</v-icon></v-btn>
			<v-btn icon x-small title="Duplicate" @click.stop="$emit('duplicate')"><v-icon small>mdi-content-copy</v-icon></v-btn>
			<v-btn icon x-small title="Settings" @click.stop="$emit('settings')"><v-icon small>mdi-cog-outline</v-icon></v-btn>
			<v-btn icon x-small title="Delete" @click.stop="$emit('remove')"><v-icon small>mdi-delete-outline</v-icon></v-btn>
		</div>
		<div
			v-if="isEditMode"
			class="db2-resize db2-resize-se"
			@mousedown.stop.prevent="onResizeStart($event, 'se')"
		></div>
		<div
			v-if="isEditMode"
			class="db2-resize db2-resize-sw"
			@mousedown.stop.prevent="onResizeStart($event, 'sw')"
		></div>
	</div>
</template>

<script>
/**
 * Shared chrome, drag handle, and resize corner for a canvas card.
 */
export default {
	name: 'DashCardShell',
	props: {
		card: { type: Object, required: true },
		isEditMode: { type: Boolean, default: false },
		selected: { type: Boolean, default: false }
	},
	computed: {
		/**
		 * Whether the title bar is shown (KPI labels live inside the card).
		 * @returns {boolean}
		 */
		showHead() {
			return this.card.type !== 'divider' && this.card.type !== 'kpi' && this.card.type !== 'energy' && this.card.type !== 'alerts' && this.card.type !== 'workOrders' && this.card.type !== 'trend' && this.card.type !== 'donut';
		}
	},
	methods: {
		/**
		 * Select this card.
		 */
		onSelect() {
			this.$emit('select');
		},
		/**
		 * Drag from the KPI body when there is no title bar.
		 * @param {MouseEvent} e
		 */
		onBodyDown(e) {
			this.onSelect();
			if (this.isEditMode && !this.showHead) this.onDragStart(e);
		},
		/**
		 * Start a move from the header or KPI body.
		 * @param {MouseEvent} e
		 */
		onDragStart(e) {
			if (!this.isEditMode) return;
			this.$emit('select');
			this.$emit('drag-start', e);
		},
		/**
		 * Start a resize from a corner handle (`se` or `sw`).
		 * @param {MouseEvent} e
		 * @param {string} edge
		 */
		onResizeStart(e, edge) {
			this.$emit('select');
			this.$emit('resize-start', { event: e, edge: edge || 'se' });
		}
	}
};
</script>
